import { combineReducers } from 'redux';

import globalLoader from './globalLoader';

export default combineReducers({
    globalLoader,
});
